<template>
  <page-list
    :list="list"
    :columns="columns"
    :export-data-options="exportDataOptions"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :placeholder="$t('common.default_search_key',['平台'])">
    <template v-slot:group-actions-append>
      <div class="d-flex align-items-center">
        <a-checkbox class="ml-2" v-model="show_enabled_only">{{$t('scope.wecom.group.only_show_enabled')}}</a-checkbox>
      </div>
    </template>
  </page-list>
</template>

<script>
import WindowsMixin from '@/mixins/windows'
import ListMixin from '@/mixins/list'
import { getEnabledSwitchActions } from '@/utils/common/tableActions'
import { getNameFilter, getDescriptionFilter, getEnabledFilter, getTimeRangeFilter } from '@/utils/common/tableFilter'
import { getNameDescriptionTableColumn, getEnabledTableColumn, getStatusTableColumn, getTimeTableColumn } from '@/utils/common/tableColumn'
import singleActionsMixin from '../mixins/singleActions'

export default {
  name: 'WecomExtGroupsList',
  mixins: [WindowsMixin, ListMixin, singleActionsMixin],
  props: {
    id: String,
  },
  data () {
    return {
      show_enabled_only: true,
      list: this.$list.createList(this, {
        id: this.id,
        resource: 'wecom_ext_groups',
        apiVersion: 'v1',
        getParams: this.getParam,
        filterOptions: {
          id: {
            label: this.$t('table.title.id'),
            filter: true,
            formatter: val => {
              return `id.contains(${val})`
            },
          },
          name: getNameFilter(),
          description: getDescriptionFilter(),
          enabled: getEnabledFilter(),
          owner: {
            label: '群主',
            dropdown: true,
            multiple: true,
            distinctField: {
              type: 'field',
              key: 'owner',
            },
          },
          created_at: getTimeRangeFilter({ field: 'created_at', label: '日期' }),
        },
      }),
      groupActions: [
        ...getEnabledSwitchActions(this, undefined, ['wecom_ext_groups_perform_enable', 'wecom_ext_groups_perform_disable'], {
          metas: [
            () => {
              const isEnable = !!this.list.selectedItems.find(item => item.enabled)
              return {
                validate: this.list.selectedItems.length && !isEnable,
              }
            },
            () => {
              const isDisable = !!this.list.selectedItems.find(item => !item.enabled)
              return {
                validate: this.list.selectedItems.length && !isDisable,
              }
            },
          ],
          resourceName: this.$t('scope.wecom_ext_groups_list'),
        }),
      ],
      columns: [
        getNameDescriptionTableColumn({
          field: 'name',
          title: '群名',
          onManager: this.onManager,
        }),
        getEnabledTableColumn(),
        getStatusTableColumn({
          field: 'status',
          title: this.$t('common.status'),
          statusModule: 'wecomExtGroups',
        }),
        getTimeTableColumn({
          field: 'created_at',
          title: '日期',
          minWidth: 100,
          format: 'YYYY-MM-DD',
        }),
        {
          field: 'owner',
          title: '群主',
        },
        {
          field: 'member_count',
          title: '用户数',
          slots: {
            default: ({ row }) => {
              return [<div> {row.member_list.length} </div>]
            },
          },
          width: 40,
        },
        {
          field: 'member_list',
          title: '用户',
          slots: {
            default: ({ row }) => {
              const ret = []
              let max = 8
              if (max > row.member_list.length) {
                max = row.member_list.length
              }
              for (let i = 0; i < max; i++) {
                ret.push(row.member_list[i].name)
              }
              if (row.member_list.length > max) {
                ret.push('...')
              }
              return [<div> {ret.join(', ')} </div>]
            },
          },
        },
        {
          field: 'associate_count',
          title: '关联业务数',
        },
        {
          field: 'associate_name',
          title: '关联业务',
        },
        {
          field: 'associate_status',
          title: '关联业务状态',
        },
      ],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        title: '企业微信群组',
        downloadType: 'local',
        items: [
          ...this.columns,
        ],
      }
    },
  },
  watch: {
    show_enabled_only (val) {
      this.list.reset()
      this.list.refresh()
    },
  },
  created () {
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        details: true,
      }
      if (this.show_enabled_only) {
        ret.enabled = true
      }
      return ret
    },
  },
}
</script>
